<template>
    <div class="min_box">
        <div class="top"  >
          触发按钮：{{btn_group_name}}-{{btn_name}}

        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange"  >
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text.site_use_count}}</a>
            </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"

            // site_use_count
    const columns = [

        {
            title: "客户名称",
            key: "company",
            dataIndex: "company",
        },
        {
            title: "触发人数",
            key: "user_num",
          dataIndex: "user_num",
        },
        {
            title: "次数",
            key: "count",
            dataIndex: "count",
        },
    ];
    export default {
        name: 'index',
        data() {
            return {
                btn_group_name:"",
                btn_name:"",
                loading: true,
                data: [],
                columns,
                name:"",
              pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
              },
              seach:{
                btn_id: this.$route.query.id,
                statistics_date:this.$route.query.statistics_date?`${this.$route.query.statistics_date[0]}~${this.$route.query.statistics_date[1]}`:""
              }

            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Behavior"; //设置左侧导航2-2 active
        },
        computed: {
            hasData() {
                return this.data.length > 0;
            },
        },
        methods: {
            handleChange(pagination, filters, sorter) {
            },
            getList(page) {
                API.service.GET_LIST({page: page || 1, ...this.seach, }).then(res => {
                    this.data = res.data.data.list.data
                  this.pagination.total=res.data.data.list.total
                  this.pagination.pageSize=res.data.data.list.per_page
                  this.pagination.current=res.data.data.list.current_page
                      this.btn_group_name=res.data.data. btn_group_name
                      this.btn_name=res.data.data.btn_name
                    this.loading = false
                })
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatistics?id=${row.id}&name=${row.name}&type=important`)
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .min_box{width:500px}
    .top{margin-bottom: 20px;}
    .num{color: #1890ff;}
</style>
